import { httpRequest } from "@/utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";

//物料信息
export interface ISCmphotoMd5 {
    photoMd5: string
}

//详情
export interface IMaterialBase {
    id: string,
    shopId: string,
    shopName: string,
    code: string,
    name: string,
    nameEn: string,
    typeCode: string,
    typeName: string,
    replaceCode: string,
    brandCode: string,
    brandName: string,
    model: string,
    madeFrom: string,
    note: string,
    unitCode: string,
    unitName: string,
    status: string | number | boolean,
    limitUpper: string,
    limitLower: string,
    minNum: string,
    purchaseNum: number,
    purchasePrice: number,
    retailPrice: number,
    wholesalePrice: number,
    createUser: string,
    createTime: string,
    updateUser: string,
    updateTime: string,
    materialCode?: string,
    materialName?: string,
    materialNameEn?: string,
    price?: number
    enable?: number

}


export interface IMaterialDetail extends IMaterialBase {
    // photo: ISCmphotoMd5[],
}

//新增
export interface IFormGoodsFields extends IMaterialBase {
    photo: string
}

//搜索条件
export interface IMaterialSearchFields {
    code?: string,
    name?: string,
    replaceCode?: string,
    typeCode?: string,
    typeName?: string,
    engineType?: string,
    orderStatus?: string,
    shopId?: string,
}

export interface IMaterialSearch
    extends IMaterialSearchFields, ISearchPage {

}

//采购物料查询searchVo
export interface IPurchaseMaterialSearch extends ISearchPage {
    codeOrName: string
}
//采购物料查询details
export interface IurchaseMaterialDetails {
    id: string,
    materialId: string,
    code: string,
    name: string,
    replaceCode: string,
    unitCode: string,
    brandCode: string,
    typeCode: string,
    retailPrice: number,
    wholesalePrice: number,
    distributorPrice: number,
    repairPrice: number,
    warehouseId: string,
    warehouseName: string,
    shelfId: string,
    shelfCode: string,
    inventoryNum: number,
}
//配件新的详情参数
export interface IMaterialBases {
    id?: string,    // "ba23132dfc3c48d864885ae16db4496b",
    code?: string,    // "004",
    name?: string,    // "干燥罐",
    typeCode?: string,    // "material-type.oils",
    typeName?: string,    // "备品",
    brandCode?: string,    // "003",
    brandName?: string,    // "潍柴",
    model?: string,    // "150ML",
    madeFrom?: string,    // "潍坊",
    unitCode?: string,    // "02",
    unitName?: string,    // "个",
    limitUpper?: number,    // 1,
    limitLower?: number,    // 10,
    purchasePrice?: string | number,    // 100,
    wholesalePrice?: string | number,    // 150,
    retailPrice?: string | number,    // 200,
    status?: string,    // 0,
    note?: string,    // "备注",
    engineType?: string,    // "全部",
    replaceCode?: string,    // "s001",
    orderNum?: string,    // null,
    createTime?: string,    // "2021-01-13",
    createUser?: string,    // "默认用户",
    updateUser?: string,    // null,
    deleteFlag?: string,    // 0
    warehouseId?: string,   //"仓库id",
    warehouseCode?: string,   //"仓库编码",
    warehouseName?: string,   //"仓库名称",
    shelfId?: string,   //"货位Id",
    shelfCode?: string,   //"货位编码",
    enable?: number

}
export type IMaterialBasesSearch = IMaterialBases
export type IMaterialBasesDetail = IMaterialBases
export interface paramsDisable {
    id:string,
    enable:number
}
class MaterialService {
    async page(searchVo: IMaterialSearch) {
        const apiUrl = "/vrm-sa/base/material/findPage";
        return await httpRequest.post<IPage<IMaterialDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/base/material/findById/${id}`;
        return await httpRequest.get<IMaterialDetail>(apiUrl);
    }
    async insert(insertVo: IMaterialBases) {
        const apiUrl = "/vrm-sa/base/material/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IMaterialBases) {
        const apiUrl = "/vrm-sa/base/material/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(params:paramsDisable) {
        const apiUrl = `/vrm-sa/base/material/change`;
        return await httpRequest.post<boolean>(apiUrl,params);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/vrm-sa/base/material/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IMaterialSearch) {
        const appPageUrl = "/vrm-sa/base/material/export";
        return await httpRequest.postFile(appPageUrl, searchVo);
    }
    //分页查询物料列表-用于采购
    async findPageByPurchase(searchVo: IurchaseMaterialDetails) {
        const appPageUrl = `/vrm-sa/base/material/findPageByPurchase`;
        return await httpRequest.post<IPage<IurchaseMaterialDetails>>(appPageUrl);
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/vrm-sa/base/material/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
    //物料导入图片
    async importImg(file: { file: File }) {
        const appPageUrl = "/vrm-sa/base/material/importImg";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
}

export const materialService = new MaterialService();